import { useEffect, useState } from "react";
import {
  Activity as ActIcon, FileText, Sparkles, GraduationCap, FileSignature, DollarSign,
  CreditCard, Target, Bell, ClipboardCheck, Circle,
} from "lucide-react";
import api from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const ICONS = {
  document: FileText, contract: FileSignature, ai: Sparkles, lesson: GraduationCap,
  funding: DollarSign, credit: CreditCard, goal: Target, report: ClipboardCheck,
  notification: Bell, formation: ClipboardCheck,
};
const MODULES = [["", "All activity"], ["document", "Documents"], ["contract", "Contracts"], ["lesson", "Education"],
  ["funding", "Funding"], ["credit", "Credit"], ["goal", "Goals"], ["report", "Reports"]];

function ago(iso) {
  try {
    const s = (Date.now() - new Date(iso).getTime()) / 1000;
    if (s < 60) return "just now";
    if (s < 3600) return `${Math.floor(s / 60)}m ago`;
    if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
    return `${Math.floor(s / 86400)}d ago`;
  } catch { return ""; }
}

export default function Timeline() {
  const [items, setItems] = useState([]);
  const [module, setModule] = useState("");
  useEffect(() => { const p = module ? `?module=${module}` : ""; api.get(`/progress/timeline${p}`).then(({ data }) => setItems(data)).catch(() => {}); }, [module]);

  return (
    <div data-testid="timeline-panel">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading text-lg text-white flex items-center gap-2"><ActIcon className="w-5 h-5 text-[#D4AF37]" /> Activity Timeline</h3>
        <Select value={module || "all"} onValueChange={(v) => setModule(v === "all" ? "" : v)}>
          <SelectTrigger className="w-40 h-9 bg-[#121214] border-white/10 text-white text-xs" data-testid="timeline-filter"><SelectValue /></SelectTrigger>
          <SelectContent className="bg-[#1C1C1F] border-white/10 text-white">
            {MODULES.map(([v, l]) => <SelectItem key={v || "all"} value={v || "all"} className="focus:bg-white/10">{l}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      {items.length === 0 ? (
        <p className="text-sm text-[#71717A] py-10 text-center" data-testid="timeline-empty">No activity yet. Actions across the platform will appear here.</p>
      ) : (
        <div className="space-y-1" data-testid="timeline-list">
          {items.map((a) => {
            const Icon = ICONS[a.kind] || Circle;
            return (
              <div key={a.activity_id} className="flex items-center gap-3 py-2.5 px-3 rounded-lg hover:bg-white/5">
                <div className="w-8 h-8 rounded-lg bg-[#D4AF37]/10 border border-[#D4AF37]/20 flex items-center justify-center text-[#D4AF37] shrink-0"><Icon className="w-4 h-4" /></div>
                <span className="text-sm text-[#D4D4D8] flex-1 min-w-0 truncate">{a.title}</span>
                <span className="text-[11px] text-[#52525B] shrink-0">{ago(a.created_at)}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
